/* eslint-disable no-unused-vars */
import * as Yup from "yup";

const saldoEmMassaValidator = Yup.object().shape({
  estoque: Yup.number()
    .typeError("Estoque")
    .required("Estoque")
    .min(0, "Estoque deve ser maior ou igual a zero"),
  filtros: Yup.object()
    .nullable()
    .test(
      "pelo-menos-um-filtro",
      "Adicione pelo menos um filtro",
      function (filtros) {
        if (!filtros) return false;
        const { porIntervalo, restritiva, produtoGrade, ...rest } = filtros;
        const temFiltroSimples = Object.values(rest).some(
          (v) => v !== null && v !== undefined && v !== "",
        );
        const temIntervalo = Array.isArray(porIntervalo) && porIntervalo.length > 0;
        return temFiltroSimples || temIntervalo;
      },
    ),
});

export default saldoEmMassaValidator;
